import {
    IFiltersResponse,
    IReferralOpportunitiesRequest,
    IReferralOpportunitiesResponse,
    IRedirectInfoResponse,
    ISurveyLinkResponse,
} from '@/types/types';
import { Config, makeFetcher } from '@/utils/fetch';
import { config } from '@/config';

const makeAffiliatesService = (apiUrl: string) => {
    const fetcher = makeFetcher(apiUrl);

    return {
        getFilters: async (config?: Config) => {
            const res = await fetcher.get('/filters', config);
            const data = (await res.json()) as IFiltersResponse;
            return data;
        },
        referralOpportunities: async (params?: IReferralOpportunitiesRequest, config?: Config) => {
            const path = '/referral-opportunities';
            const searchParams: URLSearchParams = new URLSearchParams();
            if (params?.campaignId) {
                searchParams.append('campaignId', params.campaignId.toString());
            }
            if (params?.campaignType) {
                searchParams.append('campaignType', params.campaignType.toString());
            }
            if (params?.countryCodes) {
                params.countryCodes.forEach((countryCode) => {
                    searchParams.append('countryCodes', countryCode);
                });
            }
            if (params?.professionIds) {
                params.professionIds.forEach((professionId) => {
                    searchParams.append('professionIds', professionId.toString());
                });
            }

            const res = await fetcher.get(`${path}?${searchParams.toString()}`, config);
            const data = (await res.json()) as IReferralOpportunitiesResponse;
            return data;
        },
        getRedirectInfo: async (redirectJwt: string, config?: Config) => {
            const path = '/redirect';
            const searchParams: URLSearchParams = new URLSearchParams();
            searchParams.append('redirectJwt', redirectJwt);

            const res = await fetcher.get(`${path}?${searchParams.toString()}`, config);
            const data = (await res.json()) as IRedirectInfoResponse;
            return data;
        },
        getSurveyLink: async (config?: Config) => {
            const path = '/survey-link';
            const res = await fetcher.get(path, config);
            const data = (await res.json()) as ISurveyLinkResponse;
            return data;
        },
    };
};

export const affiliatesService = makeAffiliatesService(config.api.url.affiliates);
